import React, {
  useEffect,
  useState,
  useRef,
} from 'react';
import { connect, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import {
  Card,
  Icon,
  Row,
  Col,
  Select,
  Input,
  Tooltip,
  Badge,
  Table,
} from 'antd';

import queryString from 'query-string';

import {
  SpButton,
  SpError,
  SpH5,
  SpText,
  FilterWrapper,
  SpStatusTag,
} from 'components/DesignKit';
import getScheduleReportBackground from 'utils/getScheduleReportBackground';
import getScheduleReportStatus from 'utils/getScheduleReportStatus';
import SimpleReactValidator from 'simple-react-validator';

import {
  ADMIN_SCHEDULE_REPORTS_TYPES,
  ADMIN_SCHEDULE_REPORTS_CATEGORY,
  SCHEDULE_REPORTS_PERIOD,
  PAGES,
  ROLES,
  FILTERS_TYPES,
  FILTER_STATUSES,
  MESSAGES,
  TOKENS,
} from 'appconstants';

import {
  adminschedulereportsActions,
  notificationActions,
  accountActions,
  userActions,
} from 'store/actions';

import { NOTIFICATION } from 'store/actionTypes';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';

import moment from 'moment-timezone';
import getFilterOperators from 'utils/getFilterOperators';
import FilterIcon from 'components/NavIcons/filterIcon';
import ExportIcon from 'components/NavIcons/exportIcon';

import Filters from 'components/Filters';
import Loading from 'components/Loading';
import RBAC from 'components/rbac';

import DeleteScheduleReport from './components/DeleteScheduleReport';

const MOMENT_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
const SCHEDULE_REPORTS_FILTERS_TYPES = FILTERS_TYPES.SCHEDULE_REPORTS;
const ReportTypes = FILTER_STATUSES.ADMIN_SCHEDULE_REPORTS;


const { Option } = Select;

type Props = {
  fetchAdminScheduleReports: Function,
  addAdminScheduleReport: Function,
  deleteAdminScheduleReport: Function,
  setNotification: Function,
  totalElements: number,
  reports: Array<Object>,
  loading: boolean,
  test: boolean,
  validator: boolean,
  submitting: boolean,
  selectedAccount: Object,
  history: {
    push: Function,
  },
  selectedAccount: Object,
  setSelectedAccount: Function,
  updateUserAccount: Function,
  role: Object,
  isMobileView: Boolean,
};

const AdminScheduleReport = (props: Props) => {
  const {
    loading,
    fetchAdminScheduleReports,
    addAdminScheduleReport,
    deleteAdminScheduleReport,
    setNotification,
    reports,
    totalElements,
    test,
    submitting,
    validator,
    selectedAccount,
    history,
    setSelectedAccount,
    updateUserAccount,
    role,
    isMobileView,
  } = props;

  const tableId = document.getElementsByTagName('table');
  if (tableId && tableId[0] && isMobileView) {
    tableId[0].style.width = '1600px';
  } else if (tableId && tableId[0] && !isMobileView) {
    tableId[0].style.width = '100%';
  }

  const location = useLocation();
  const {
    filteredList,
    accounts,
  } = useSelector(state => state.account);
  const [, forceUpdate] = useState();
  const [pagination, setPagination] = useState({});
  const [reportType, setReportType] = useState();
  const [reportCategory, setReportCategory] = useState();
  const [reportPeriod, setReportPeriod] = useState();
  const [addRecipient, setAddRecipient] = useState(null);
  const myRef = useRef();
  const [open, setOpen] = useState(false);
  const [filterTypes, setFilterTypes] = useState(SCHEDULE_REPORTS_FILTERS_TYPES);
  const [fiterOperators, setFilterOperators] = useState([]);
  const [filterScheduleReports, setfilterScheduleReports] = useState([{
    filterType: '',
    filterName: '',
    filterOperator: '',
    filterValue: '',
    filterNameDisplay: '',
    filterValueFrom: '',
    filterValueTo: '',
    checked: true,
  }]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [currentDate, setCurrentDate] = useState('');
  const [count, setCount] = useState(null);
  const [fillColor, setFillColor] = useState(false);
  const [filterColor, setFilterColor] = useState(false);
  const [deleteReportModal, setDeleteReportModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState({});
  const accntGid = selectedAccount && selectedAccount.gid;

  const simpleValidator = useRef(new SimpleReactValidator({
    autoForceUpdate: {
      forceUpdate,
    },
    validators: {
      checkLowerCase: {
        message: 'Email address must not contain uppercase letters.',
        rule: (val) => val === val.toLowerCase(),
      },
    },
  }));

  const getData = (query) => {
    const parsed = queryString.parse(query);
    const currentPage = parsed.pageNum || 1;
    const sortBy = parsed.sortBy || 'createdAt';
    const direction = parsed.direction || 'DESC';
    const sortParams = `&sortBy=${sortBy}&direction=${direction}`;
    const filterParams = parsed.filterParams || '';
    fetchAdminScheduleReports({ currentPage, sortParams, filterParams });
  };

  useEffect(() => {
    getData(location.search);
  }, []);

  useEffect(() => {
    if (!validator) {
      setDeleteReportModal(false);
    }
  }, [validator]);

  const showDeleteReportModal = (value: Object) => {
    setSelectedReport(value);
    setDeleteReportModal(true);
  };

  const getReport = async (reportGid) => {
    try {
      const { data: { entity: { fileUrl } } } = await axiosAuthInstance
        .get(`${API_END_POINTS.ADMIN_SCHEDULE_REPORTS}/${reportGid}/download`);
      window.open(fileUrl);
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: MESSAGES.SCHEDULE_REPORTS.DOWNLOAD_ERROR,
      });
    } finally {
      history.push(PAGES.ADMIN_SCHEDULE_REPORTS);
    }
  };

  const switchAccountAndGetReport = async (gid, reportGid) => {
    try {
      // This call is happennig in Partnerlist component as well.
      // any change you make here please make sure to change in Partnerlist component as well.
      if ((role && role.name) === ROLES.SUPERUSER) {
        const API_END_POINT = `/internal${API_END_POINTS.JWE}/${gid}/switch?isTest=false`;
        const { data: { entity: { token: { accessToken } } } } = await axiosAuthInstance.get(API_END_POINT);
        localStorage.setItem(TOKENS.ACCESS_TOKEN, accessToken);
        setSelectedAccount(filteredList.content.find(a => a.gid === gid));
        updateUserAccount(gid);
      } else {
        const API_END_POINT = `${API_END_POINTS.JWE}/${gid}/switch?isTest=false`;
        const { data: { entity: { token: { accessToken } } } } = await axiosAuthInstance.get(API_END_POINT);
        localStorage.setItem(TOKENS.ACCESS_TOKEN, accessToken);
        // update selectedAccount
        setSelectedAccount(accounts.content.find(a => a.gid === gid));
        updateUserAccount(gid);
      }
      getReport(reportGid);
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: e.response ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  };

  useEffect(() => {
    const parsed = queryString.parse(location.search);
    const reportGid = parsed['admin-scheduled-report-gid'];
    const accountGid = parsed['account-gid'];
    if (reportGid) {
      if (accountGid && (accountGid === accntGid)) {
        getReport(reportGid);
      } else if (accountGid && (accountGid !== accntGid)) {
        switchAccountAndGetReport(accountGid, reportGid);
      } else {
        getReport(reportGid);
      }
    }
  }, [location]);

  const exportData = reports ? reports.map((values) => ({
    type: values.type,
    frequency: values.frequency,
    lastGeneratedAt: values.lastGeneratedAt ? moment
      .utc(values.lastGeneratedAt)
      .tz(selectedAccount.timezone)
      .format('MMM DD, YYYY, hh:mm a') : '',
    status: getScheduleReportStatus(values.status),
  })) : '';

  const exportHeaders = [
    { label: 'Report Type', key: 'type' },
    { label: 'Period', key: 'frequency' },
    { label: 'Last Processed', key: 'lastGeneratedAt' },
    { label: 'Status', key: 'status' },
  ];

  const handleClick = e => {
    if (myRef.current && myRef.current.contains(e.target)) {
      return;
    }
    if (e.target.value === undefined
      && e.toElement.className !== 'ant-calendar-date'
      && e.toElement.className !== 'ant-calendar-prev-month-btn'
      && e.toElement.className !== 'ant-calendar-next-month-btn') {
      setOpen(false);
    }
  };

  useEffect(() => {
    getData(location.search);
  }, [location, test, selectedAccount]);


  useEffect(() => {
    const parsed = queryString.parse(location.search);
    const currentPage = parsed.pageNum || 1;
    setPagination(existingElements => ({
      ...existingElements,
      total: totalElements,
      current: parseInt(currentPage, 10),
      showTotal: total => `Total ${total} items`,
    }));
  }, [reports]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  const addNewRecipient = (event) => {
    event.preventDefault();
    if (addRecipient) {
      setAddRecipient([...addRecipient, '']);
    } else {
      setAddRecipient(['']);
    }
  };
  const handleRemoveEmail = (i) => {
    const list = [...addRecipient];
    list.splice(i, 1);
    setAddRecipient(list);
    const hasNoEmails = (list.length === 0);
    if (hasNoEmails) {
      simpleValidator.current.purgeFields();
    }
  };

  const generateScheduleReport = async (event) => {
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    const params = {
      type: reportType,
      notification: 'EMAIL',
      frequency: reportPeriod,
      reportCategory,
      recipientList: addRecipient || null,
    };
    simpleValidator.current.hideMessages();
    addAdminScheduleReport({ params });
  };

  useEffect(() => {
    if (!validator) {
      setReportType();
      setReportPeriod();
      setReportCategory();
      setAddRecipient(null);
    }
  }, [validator]);

  const deleteReport = (gid: string) => {
    deleteAdminScheduleReport(gid);
  };

  const handleTableChange = (page, sorter, filters) => {
    const parsed = queryString.parse(location.search);
    const filterParams = parsed.filterParams || '';
    const tempPage = page.current;
    let tempParams = '';
    if (filters.order === 'ascend') {
      tempParams = `&sortBy=${filters.field}&direction=ASC`;
    } else if (filters.order === 'descend') {
      tempParams = `&sortBy=${filters.field}&direction=DESC`;
    } else {
      tempParams = '';
    }
    if (location.search && filterParams) {
      const filterParam = encodeURIComponent(filterParams);
      history.push({
        pathname: PAGES.ADMIN_SCHEDULE_REPORTS,
        search: `?filterParams=${filterParam}&pageNum=${tempPage}${tempParams}`,
      });
    } else {
      history.push({
        pathname: PAGES.ADMIN_SCHEDULE_REPORTS,
        search: `?pageNum=${tempPage}${tempParams}`,
      });
    }
  };

  const onCheck = (e, index) => {
    const list = [...filterScheduleReports];
    if (filterScheduleReports.length !== 1) {
      if (!e) {
        list.splice(index, 1);
        const filterTypeOptions = SCHEDULE_REPORTS_FILTERS_TYPES.filter(({ value: id1 }) => !list.some(({ filterName: id2 }) => id2 === id1));
        setFilterTypes(filterTypeOptions);
      } else {
        list[index].checked = e;
      }
    }
    setfilterScheduleReports(list);
  };

  const handleChange = (e, index) => {
    const list = [...filterScheduleReports];
    if (e[1] === 'createdAt') {
      list[index].filterType = 'Date';
    } else if (e[1] === 'amount') {
      list[index].filterType = 'Number';
    } else if (e[1] === 'status') {
      list[index].filterType = 'Dropdown';
    } else if (e[1] === 'type') {
      list[index].filterType = 'Dropdown';
    } else {
      list[index].filterType = 'String';
    }
    list[index].filterName = e[1];
    list[index].filterNameDisplay = e[0];
    list[index].filterOperator = '';
    list[index].filterValue = '';
    const filterTypeOptions = SCHEDULE_REPORTS_FILTERS_TYPES.filter(({ value: id1 }) => !list.some(({ filterName: id2 }) => id2 === id1));
    setfilterScheduleReports(list);
    setFilterTypes(filterTypeOptions);
    setFilterOperators(getFilterOperators(e[1]));
  };

  const handleFromValue = (e, index) => {
    const list = [...filterScheduleReports];
    const regex = /^\d*\.?\d*$/;
    if (e.currentTarget && regex.test(e.currentTarget.value.replace(/,/g, ''))) {
      list[index].filterValueFrom = e.currentTarget.value;
      setfilterScheduleReports(list);
    } else if (regex.test(e.replace(/,/g, ''))) {
      list[index].filterValueFrom = e;
      setfilterScheduleReports(list);
    }
  };

  const handleToValue = (e, index) => {
    const list = [...filterScheduleReports];
    const regex = /^\d*\.?\d*$/;
    if (e.currentTarget && regex.test(e.currentTarget.value.replace(/,/g, ''))) {
      list[index].filterValueTo = e.currentTarget.value;
      setfilterScheduleReports(list);
    } else if (regex.test(e.replace(/,/g, ''))) {
      list[index].filterValueTo = e;
      setfilterScheduleReports(list);
    }
  };

  const handleValue = (e, index) => {
    let selectedValue = '';
    if (filterScheduleReports[index].filterName === 'createdAt') {
      if (filterScheduleReports[index].filterOperator === 'BT') {
        const date1 = e[0];
        const date2 = e[1];
        const utcDate1 = moment(date1).startOf('day');
        setStartDate(utcDate1);
        const utcDate2 = moment(date2).startOf('day');
        setEndDate(utcDate2);
        const utcString1 = utcDate1.format(MOMENT_FORMAT);
        const utcString2 = utcDate2.format(MOMENT_FORMAT);
        const selectedDate1 = moment.tz(utcString1, selectedAccount.timezone);
        const selectedDate2 = moment.tz(utcString2, selectedAccount.timezone);
        const dateStart = selectedDate1.utc().format(MOMENT_FORMAT);
        const dateEnd = selectedDate2.utc().format(MOMENT_FORMAT);
        selectedValue = `createdAt.GT=${dateStart}&createdAt.LT=${dateEnd}`;
      } else if (filterScheduleReports[index].filterOperator === 'LT') {
        const utcDate = moment(e).startOf('day');
        setCurrentDate(utcDate);
        const utcString = utcDate.format(MOMENT_FORMAT);
        const dateSelected = moment.tz(utcString, selectedAccount.timezone);
        const dateStart = dateSelected.utc().format(MOMENT_FORMAT);
        selectedValue = `createdAt.LT=${dateStart}`;
      } else if (filterScheduleReports[index].filterOperator === 'GT') {
        const utcDate = moment(e).startOf('day');
        setCurrentDate(utcDate);
        const utcString = utcDate.format(MOMENT_FORMAT);
        const dateSelected = moment.tz(utcString, selectedAccount.timezone);
        const dateStart = dateSelected.utc().format(MOMENT_FORMAT);
        selectedValue = `createdAt.GT=${dateStart}`;
      }
    } else if (filterScheduleReports[index].filterName === 'status') {
      selectedValue = e;
    } else {
      if (!e.currentTarget) {
        selectedValue = e;
      }
      if (e.currentTarget && e.currentTarget.value) {
        selectedValue = e.currentTarget.value;
      }
    }
    const list = [...filterScheduleReports];
    list[index].filterValue = selectedValue;
    setfilterScheduleReports(list);
  };

  const handleOperator = (e, index) => {
    const list = [...filterScheduleReports];
    list[index].filterOperator = e;
    if (list[index].filterValue) {
      if (list[index].filterOperator !== 'BT'
        && list[index].filterName === 'createdAt') {
        handleValue(currentDate, index);
      } else if (list[index].filterOperator === 'BT'
        && list[index].filterName === 'createdAt') {
        const dateList = [startDate, endDate];
        handleValue(dateList, index);
      } else if (list[index].filterOperator !== 'BT'
        && list[index].filterOperator !== 'LT'
        && list[index].filterOperator !== 'GT') {
        const value = filterScheduleReports[index].filterValue;
        handleValue(value, index);
      }
    }
    setfilterScheduleReports(list);
  };

  const handleAddClick = () => {
    const list = [...filterScheduleReports];
    setfilterScheduleReports([...list, {
      filterType: '',
      filterName: '',
      filterOperator: '',
      filterValue: '',
      filterNameDisplay: '',
      filterValueFrom: '',
      filterValueTo: '',
      checked: true,
    }]);
  };

  const resetFilters = () => {
    setfilterScheduleReports([{
      filterType: '',
      filterName: '',
      filterOperator: '',
      filterValue: '',
      filterNameDisplay: '',
      filterValueFrom: '',
      filterValueTo: '',
      checked: true,
    }]);
    setFilterTypes(SCHEDULE_REPORTS_FILTERS_TYPES);
    setStartDate('');
    setEndDate('');
    setCurrentDate('');
    setCount(null);
    history.push(PAGES.ADMIN_SCHEDULE_REPORTS);
  };

  const applyFilters = () => {
    const paymentsFilters = filterScheduleReports.filter((item) => item.checked);
    for (let i = 0; i < paymentsFilters.length; i += 1) {
      if (!paymentsFilters[i].filterName || !paymentsFilters[i].filterOperator || !paymentsFilters[i].filterValue) {
        return;
      }
    }
    if (paymentsFilters[0].filterValue || (paymentsFilters[0].filterValueFrom && paymentsFilters[0].filterValueTo)) {
      setCount(paymentsFilters && paymentsFilters.length);
      for (let i = 0; i < paymentsFilters.length; i += 1) {
        if (paymentsFilters[i].checked) {
          if (paymentsFilters[i].filterName === 'createdAt') {
            paymentsFilters[i] = paymentsFilters[i].filterValue;
          } else if (paymentsFilters[i].filterName === 'amount' && paymentsFilters[i].filterOperator === 'BT') {
            const name = paymentsFilters[i].filterName;
            const from = paymentsFilters[i].filterValueFrom.replace(/[. ,:-]+/g, '');
            const to = paymentsFilters[i].filterValueTo.replace(/[. ,:-]+/g, '');
            paymentsFilters[i] = `${name}.GT=${from}&${name}.LT=${to}`;
          } else if (paymentsFilters[i].filterName === 'amount' && paymentsFilters[i].filterOperator !== 'BT') {
            const value = paymentsFilters[i].filterValue.replace(/[. ,:-]+/g, '');
            paymentsFilters[i] = `${paymentsFilters[i].filterName}.${paymentsFilters[i].filterOperator}=${value}`;
          } else if (paymentsFilters[i].filterName === 'email') {
            const email = encodeURIComponent(paymentsFilters[i].filterValue);
            paymentsFilters[i] = `${paymentsFilters[i].filterName}.${paymentsFilters[i].filterOperator}=${email}`;
          } else {
            paymentsFilters[i] = `${paymentsFilters[i].filterName}.${paymentsFilters[i].filterOperator}=${paymentsFilters[i].filterValue}`;
          }
        }
      }

      const filterParams = encodeURIComponent(paymentsFilters.join('&'));
      const parsed = queryString.parse(location.search);
      const currentPage = 1;
      const sortBy = parsed.sortBy || 'createdAt';
      const direction = parsed.direction || 'DESC';
      const sortParams = `&sortBy=${sortBy}&direction=${direction}`;
      if (location.search && parsed.sortBy && parsed.pageNum && parsed.direction) {
        history.push({
          pathname: PAGES.ADMIN_SCHEDULE_REPORTS,
          search: `?filterParams=${filterParams}&pageNum=${currentPage}${sortParams}`,
        });
      } else {
        history.push({
          pathname: PAGES.ADMIN_SCHEDULE_REPORTS,
          search: `?filterParams=${filterParams}`,
        });
      }
      setOpen(false);
    }
  };

  const columns = [
    {
      title: 'Report Type',
      dataIndex: 'type',
      width: '25%',
      align: 'left',
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (name) => (
        <span style={{ cursor: 'pointer' }}>
          {name}
        </span>
      ),
    },
    {
      title: 'Period',
      dataIndex: 'frequency',
      width: '15%',
      align: 'left',
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (email) => (
        <span style={{ cursor: 'pointer' }}>
          {email}
        </span>
      ),
    },
    {
      title: 'Last Processed',
      dataIndex: 'lastGeneratedAt',
      width: '20%',
      align: 'left',
      sorter: true,
      defaultSortOrder: 'descend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (lastGeneratedAt) => {
        if (lastGeneratedAt && selectedAccount && selectedAccount.timezone) {
          const tzDate = moment
            .utc(lastGeneratedAt)
            .tz(selectedAccount.timezone)
            .format('MMM DD, YYYY, hh:mm a');
          return (<span>{tzDate}</span>);
        }
        return (
          <>&#8211;</>
        );
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      width: '15%',
      align: 'left',
      sorter: false,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (status) => (
        <SpStatusTag style={{ backgroundColor: getScheduleReportBackground(status) }}>
          {getScheduleReportStatus(status)}
        </SpStatusTag>
      ),
    },
  ];

  const actionColumn = {
    title: 'ACTION',
    dataIndex: 'action',
    width: '15%',
    align: 'center',
    render: (text, record) => (
      <span>
        <Tooltip placement="top" title="Delete">
          <Icon
            type="delete"
            style={{ fontSize: '20px', marginRight: '8px', cursor: 'pointer' }}
            onClick={() => showDeleteReportModal(record)}
          />
        </Tooltip>
      </span>
    ),
  };


  if (loading || !selectedAccount) {
    return <Loading />;
  }

  return (
    <>
      {
        test
          ? (
            <Card
              className="mx-auto mt-5"
              style={{ width: 500, height: 250, boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.3)' }}
              bodyStyle={{ height: '100%' }}
            >
              <div className="d-flex flex-column align-items-center justify-content-center mx-auto h-100">
                <Icon
                  type="exclamation-circle"
                  className="mb-4"
                  style={{ color: 'red', fontSize: '32px', textAlign: 'center' }}
                />
                <SpText fontSize="20px">Schedule Reports are only available for live data</SpText>
              </div>
            </Card>
          )
          : (
            <Card>
              <RBAC
                permit={
                  [ROLES.OWNER, ROLES.ADMINISTRATOR, ROLES.ANALYST,
                    ROLES.OPERATIONS, ROLES.DEVELOPER, ROLES.SUPPORT, ROLES.SUPERUSER, ROLES.INTERNALSUPPORT, ROLES.ONBOARDING]
                }
              >
                <Row className="my-2 mb-3">
                  <Col>
                    <SpText fontSize="20px">Generate Report</SpText>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <SpH5 fontSize="20px">Report Type</SpH5>
                  </Col>
                </Row>
                <Row className="mb-3 mt-3">
                  <Col span={7}>
                    <Select
                      className="w-100"
                      placeholder="Select Report Type"
                      onChange={value => setReportType(value)}
                      value={reportType}
                    >
                      {
                        ADMIN_SCHEDULE_REPORTS_TYPES.map(report => (
                          <Option
                            key={1}
                            value={report.value}
                            className="text-capitalize"
                          >
                            {report.display}
                          </Option>
                        ))
                      }
                    </Select>
                    <SpError>
                      {simpleValidator.current.message('Report Type', reportType, 'required')}
                    </SpError>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <SpH5 fontSize="20px">Report Category</SpH5>
                  </Col>
                </Row>
                <Row className="mt-3 mb-3">
                  <Col span={7}>
                    <Select
                      className="w-100"
                      placeholder="Select Report Category"
                      onChange={value => setReportCategory(value)}
                      value={reportCategory}
                    >
                      {
                        ADMIN_SCHEDULE_REPORTS_CATEGORY.map(report => (
                          <Option
                            key={1}
                            value={report.value}
                            className="text-capitalize"
                          >
                            {report.display}
                          </Option>
                        ))
                      }
                    </Select>
                    <SpError>
                      {simpleValidator.current.message('Report Category', reportCategory, 'required')}
                    </SpError>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <SpH5 fontSize="20px">Period</SpH5>
                  </Col>
                </Row>
                <Row className="mt-3 mb-3">
                  <Col span={7}>
                    <Select
                      className="w-100"
                      placeholder="Select Report Period"
                      onChange={value => setReportPeriod(value)}
                      value={reportPeriod}
                    >
                      {
                        SCHEDULE_REPORTS_PERIOD.map(report => (
                          <Option
                            key={1}
                            value={report.value}
                          >
                            {report.display}
                          </Option>
                        ))
                      }
                    </Select>
                    <SpError>
                      {simpleValidator.current.message('Report Period', reportPeriod, 'required')}
                    </SpError>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <SpH5 fontSize="20px">Email Recipient List</SpH5>
                  </Col>
                </Row>
                {addRecipient && addRecipient.map((item, i) => (
                  <div className="mb-3">
                    <Row>
                      <Col span={7}>
                        <Input
                          value={item}
                          key={`Email${i}`}
                          onChange={(e) => {
                            const list = [...addRecipient];
                            list[i] = e.currentTarget.value;
                            setAddRecipient(list);
                          }}
                          placeholder="Email"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8} className="d-flex justify-content-end">
                        <Icon
                          type="minus-circle"
                          style={{
                            cursor: 'pointer', color: '#ff4d50', marginTop: '-25px', marginRight: '25px',
                          }}
                          onClick={() => handleRemoveEmail(i)}
                        />
                      </Col>
                    </Row>
                    <SpError className="mb-4">
                      {simpleValidator.current.message('email', item, 'required|email|checkLowerCase',
                        { messages: { email: 'The email must be valid' } })}
                    </SpError>
                  </div>
                ))}
                <Row className="mt-3 mb-3">
                  <Col style={{ cursor: 'pointer' }}>
                    <SpText
                      fontWeight="600"
                      color="#279dfe"
                      onClick={addNewRecipient}
                    >
                      Add New Recipient
                    </SpText>
                  </Col>
                </Row>
                <Row className="mt-3 mb-3">
                  <Col>
                    <SpButton
                      className="mr-4"
                      type="primary"
                      shape="round"
                      onClick={generateScheduleReport}
                    >
                      Add Schedule Report
                    </SpButton>
                  </Col>
                </Row>
              </RBAC>
              <>
                <Row type="flex" justify="space-between" className="mb-4 mt-5">
                  <Col>
                    <SpText className="mb-3" fontSize="20px">Schedule Reports</SpText>
                  </Col>
                  <Col>
                    <span>
                      {
                        exportData !== null
                          ? (
                            <Tooltip placement="left" title="Click here to export Schedule Reports">
                              <CSVLink
                                target="_blank"
                                className="mr-3"
                                filename="Schedule Reports.csv"
                                data={exportData}
                                headers={exportHeaders}
                                onMouseEnter={() => setFillColor(true)}
                                onMouseLeave={() => setFillColor(false)}
                              >
                                <ExportIcon
                                  fill={fillColor
                                    ? '#279dfe'
                                    : '#C0C0C0'}
                                />
                              </CSVLink>
                            </Tooltip>
                          ) : null
                      }
                    </span>
                    <span ref={myRef}>
                      <span
                        onClick={() => setOpen(!open)}
                        style={{ cursor: 'pointer' }}
                        onMouseEnter={() => setFilterColor(true)}
                        onMouseLeave={() => setFilterColor(false)}
                      >
                        {open && (
                          <Badge count={count} style={{ backgroundColor: '#0090ff' }}>
                            <FilterIcon
                              fill={filterColor
                                ? '#279dfe'
                                : '#C0C0C0'}
                            />
                          </Badge>
                        )}
                        {!open && (
                          <Tooltip placement="left" title="Click here to filter Reports">
                            <Badge count={count} style={{ backgroundColor: '#0090ff' }}>
                              <FilterIcon
                                fill={filterColor
                                  ? '#279dfe'
                                  : '#C0C0C0'}
                              />
                            </Badge>
                          </Tooltip>
                        )}
                      </span>
                      {open && (
                        <FilterWrapper
                          style={{ marginLeft: '-264px' }}
                        >
                          <Filters
                            filtersGrid={filterScheduleReports}
                            filterTypes={filterTypes}
                            handleChange={handleChange}
                            onCheck={onCheck}
                            fiterOperators={fiterOperators}
                            handleOperator={handleOperator}
                            handleValue={handleValue}
                            startDate={startDate}
                            endDate={endDate}
                            currentDate={currentDate}
                            handleFromValue={handleFromValue}
                            handleToValue={handleToValue}
                            stuses={ReportTypes}
                          />
                          <div className="px-4 mt-2">
                            {
                              filterScheduleReports.length < SCHEDULE_REPORTS_FILTERS_TYPES.length && (
                                <div className="mb-2 ml-3" style={{ cursor: 'pointer' }}>
                                  <SpText
                                    fontWeight="600"
                                    color="#279dfe"
                                    onClick={handleAddClick}
                                  >
                                    +&nbsp; Add another filter
                                  </SpText>
                                </div>
                              )
                            }
                          </div>
                          <div className="d-flex mb-2 justify-content-end mr-3">
                            <SpButton
                              type="secondary"
                              shape="round"
                              className="mr-2"
                              ghost
                              onClick={resetFilters}
                            >
                              Clear
                            </SpButton>
                            <SpButton
                              type="primary"
                              shape="round"
                              onClick={applyFilters}
                            >
                              Save
                            </SpButton>
                          </div>
                        </FilterWrapper>
                      )}
                    </span>
                  </Col>
                </Row>
                {/* DELETE REPORT MODAL */}
                {deleteReportModal && (
                  <DeleteScheduleReport
                    visible={deleteReportModal}
                    selectedReport={selectedReport}
                    submitting={submitting}
                    submit={deleteReport}
                    close={() => setDeleteReportModal(false)}
                  />
                )}
                <Table
                  columns={[...columns, actionColumn]}
                  dataSource={reports}
                  pagination={pagination}
                  onChange={handleTableChange}
                />
              </>
            </Card>
          )
      }
    </>
  );
};

const mapStateToProps = (state) => ({
  loading: state.loading.loading,
  reports: state.adminschedulereports.content,
  user: state.user,
  test: state.account.test,
  submitting: state.loading.submitting,
  validator: state.loading.validator,
  totalElements: state.adminschedulereports.totalElements,
  selectedAccount: state.account.selectedAccount,
  role: (state.user.internalRole ? state.user.internalRole : state.user.role),
  isMobileView: state.mobileView.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAdminScheduleReports: param => dispatch(adminschedulereportsActions.fetchAdminScheduleReports({
    payload: param,
  })),
  addAdminScheduleReport: param => dispatch(adminschedulereportsActions.addAdminScheduleReport({
    payload: param,
  })),
  deleteAdminScheduleReport: param => dispatch(adminschedulereportsActions.deleteAdminScheduleReport({
    payload: param,
  })),
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
  setSelectedAccount: account => dispatch(accountActions.setSelectedAccount(account)),
  updateUserAccount: account => dispatch(userActions.updateUserAccount(account)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminScheduleReport);
